import{select as e,take as o}from"@redux-saga/core/effects";function*r(r,f){(yield e(r))||(yield o(f))}export{r as waitForFulfilled};
//# sourceMappingURL=waitForFulfilled.js.map
